import type { InjectionKey, Ref } from 'vue';
import { CLIENT_DEVICE } from '@monolith/legacy/modules/design-system-candidates/breakpoints';

export const IS_QUICKVIEW_KEY: InjectionKey<Ref<boolean>> = Symbol('is-quickview');

export const MAX_ITEMS = Object.freeze({
  default: {
    [CLIENT_DEVICE.mobile]: 2.4,
    [CLIENT_DEVICE.tablet]: 3.4,
    [CLIENT_DEVICE.desktop]: 4.4,
  },
  categories: {
    [CLIENT_DEVICE.mobile]: 2.4,
    [CLIENT_DEVICE.tablet]: 3.4,
    [CLIENT_DEVICE.desktop]: 4.4,
  },
  quickview: {
    [CLIENT_DEVICE.mobile]: 2.4,
    [CLIENT_DEVICE.tablet]: 3.4,
    [CLIENT_DEVICE.desktop]: 3.4,
  },
});

export const PER_MOVE = Object.freeze({
  default: {
    [CLIENT_DEVICE.mobile]: Math.max(1, Math.round(MAX_ITEMS.default[CLIENT_DEVICE.mobile] - 1)),
    [CLIENT_DEVICE.tablet]: Math.max(1, Math.round(MAX_ITEMS.default[CLIENT_DEVICE.tablet] - 1)),
    [CLIENT_DEVICE.desktop]: Math.max(1, Math.round(MAX_ITEMS.default[CLIENT_DEVICE.desktop] - 1)),
  },
  categories: {
    [CLIENT_DEVICE.mobile]: Math.max(1, Math.round(MAX_ITEMS.categories[CLIENT_DEVICE.mobile] - 1)),
    [CLIENT_DEVICE.tablet]: Math.max(1, Math.round(MAX_ITEMS.categories[CLIENT_DEVICE.tablet] - 1)),
    [CLIENT_DEVICE.desktop]: Math.max(1, Math.round(MAX_ITEMS.categories[CLIENT_DEVICE.desktop] - 1)),
  },
  quickview: {
    [CLIENT_DEVICE.mobile]: Math.max(1, Math.round(MAX_ITEMS.quickview[CLIENT_DEVICE.mobile] - 1)),
    [CLIENT_DEVICE.tablet]: Math.max(1, Math.round(MAX_ITEMS.quickview[CLIENT_DEVICE.tablet] - 1)),
    [CLIENT_DEVICE.desktop]: Math.max(1, Math.round(MAX_ITEMS.quickview[CLIENT_DEVICE.desktop] - 1)),
  },
});

export const ITEM_PREVIEW_RATIO = Object.freeze({
  [CLIENT_DEVICE.mobile]: 1 / 5,
  [CLIENT_DEVICE.tablet]: 3 / 5,
  [CLIENT_DEVICE.desktop]: 1 / 2,
});

export const MAX_ITEM_PREVIEW_RATIO = 0;

export const ITEM_SPACING = 24;
export const ITEM_SPACING_MOBILE = 16;
